<template>

<div>

	
 

<template v-if="data.options.length">
  <template v-if="data.horizontal_select">
    <div class="flex">
      <SelectOption v-for="item in data.options" :item="item" :key="item.id" :nulled="nulled" :selected="inputdata" @optionSelected="fieldChanged" :readonly="data.read_only_state"></SelectOption>
    </div>
  </template>
  <template v-else>
    <SelectOption v-for="item in data.options" :item="item" :key="item.id" :nulled="nulled" :selected="inputdata" @optionSelected="fieldChanged" :readonly="data.read_only_state"></SelectOption>
  </template>
	
</template>


</div>

</template>

<script>
import SelectOption from "./SelectOption"
export default {

  name: 'SelectType',
  props:["data"],
  components:{SelectOption},
  data () {
    return {
    	inputdata:null,
    	intervalobj:null,
    }
  },
  mounted()
  {
  	if(this.data.submissions.length>0)
  	{
  		this.inputdata = this.data.submissions[0].submission_option
  	}
    else
      {
        this.inputdata = null
      }
  },
  computed:{

    propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_option
        return propdata
      }
    },
     nulled()
    {

      if(this.data.submissions.length && this.data.submissions[0].is_nulled)
      {
        return true
      }
      else
      {
        return false
      }
    }
  },
  watch:{

    propdata(newval)
    {
      this.inputdata = newval
    },
    data()
    {
      if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_option
      }
      else
      {
        this.inputdata = null
      }
    }
  },
  methods: {
  	fieldChanged(event)
  	{
      
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
  		this.inputdata = event
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},1000)
  	},
  	submitInputData()
  	{
  		clearInterval(this.intervalobj);
  		let formdata = new FormData()
      //console.log("text field")
      //console.log(this.inputdata)
      //console.log(this.data)
      if(this.data.submissions.length && this.data.submissions[0].submission_option == this.inputdata)
      {
        formdata.append("option",null)
      }
      else
      {
        formdata.append("option",this.inputdata)
      }
  		
  		formdata.append("type","select")
  		formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
      console.log(this.$store.state.audit.audit)
      

  		//return false
      this.submitInputFieldAuditSubmission(formdata,this.data.id)
  		//this.generalSubmission(formdata,"audit/submit_inputfield_submission/"+this.data.id,this.aftersubmitInputData)
  	},
  }
};
</script>

<style lang="css" scoped>
</style>